import React, { useEffect, useState } from "react";
import api from "../../services/api";

const formatDate = value => {
  if (!value) return "-";

  return new Date(value).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

const RecoveryManualCanceledCard = () => {
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState({});
  const [latest, setLatest] = useState([]);

  const loadData = async () => {
    setLoading(true);

    try {
      const { data } = await api.get("/dashboard/recovery/canceled-manual");
      setSummary(data.summary || {});
      setLatest(data.latest || []);
    } catch (error) {
      console.error("Erro ao carregar cancelados manualmente:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const openTicket = ticketUuid => {
    if (!ticketUuid) return;
    window.open(`/tickets/${ticketUuid}`, "_blank");
  };

  const reactivateSchedule = async item => {
    const ok = window.confirm(
      `Reativar o disparo para ${item.contactName || "este cliente"}?\n\nMensagem:\n${item.cleanMessage || ""}`
    );

    if (!ok) return;

    try {
      await api.put(`/dashboard/recovery/canceled-manual/${item.id}/reactivate`);
      await loadData();
    } catch (error) {
      console.error("Erro ao reativar disparo:", error);
      alert("Não foi possível reativar o disparo. Verifique se a data ainda não venceu.");
    }
  };

  return (
    <div
      style={{
        marginTop: 24,
        background: "#fff",
        borderRadius: 14,
        padding: 20,
        boxShadow: "0 2px 10px rgba(0,0,0,0.06)"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 13, color: "#64748b", fontWeight: 800 }}>
            Controle da Régua
          </div>
          <h2 style={{ margin: 0, fontSize: 22 }}>Cancelados manualmente</h2>
          <div style={{ fontSize: 13, color: "#64748b" }}>
            Disparos bloqueados antes de serem enviados ao cliente.
          </div>
        </div>

        <button
          type="button"
          onClick={loadData}
          disabled={loading}
          style={{
            border: 0,
            borderRadius: 10,
            padding: "10px 16px",
            background: "#dc2626",
            color: "#fff",
            fontWeight: 800,
            cursor: loading ? "not-allowed" : "pointer"
          }}
        >
          {loading ? "Atualizando..." : "Atualizar"}
        </button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(160px, 1fr))", gap: 12, marginBottom: 16 }}>
        <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, padding: 14, background: "#fff7ed" }}>
          <div style={{ color: "#9a3412", fontSize: 12, fontWeight: 800 }}>Total cancelado manualmente</div>
          <div style={{ fontSize: 28, fontWeight: 900 }}>{summary.canceledManual || 0}</div>
        </div>

        <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, padding: 14, background: "#fef2f2" }}>
          <div style={{ color: "#991b1b", fontSize: 12, fontWeight: 800 }}>Cancelados hoje</div>
          <div style={{ fontSize: 28, fontWeight: 900 }}>{summary.canceledToday || 0}</div>
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
          <thead>
            <tr style={{ background: "#f8fafc", color: "#475569", textAlign: "left" }}>
              <th style={{ padding: 10 }}>Cancelado em</th>
              <th style={{ padding: 10 }}>Cliente</th>
              <th style={{ padding: 10 }}>Telefone</th>
              <th style={{ padding: 10 }}>Vendedor</th>
              <th style={{ padding: 10 }}>Mensagem cancelada</th>
              <th style={{ padding: 10 }}>Ação</th>
            </tr>
          </thead>

          <tbody>
            {latest.length === 0 && (
              <tr>
                <td colSpan="6" style={{ padding: 16, color: "#64748b", textAlign: "center" }}>
                  Nenhum disparo cancelado manualmente ainda.
                </td>
              </tr>
            )}

            {latest.map(item => (
              <tr key={item.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                <td style={{ padding: 10, fontWeight: 800 }}>{formatDate(item.canceledAt)}</td>
                <td style={{ padding: 10, fontWeight: 800 }}>{item.contactName || "-"}</td>
                <td style={{ padding: 10 }}>{item.contactNumber || "-"}</td>
                <td style={{ padding: 10 }}>{item.sellerName || "-"}</td>
                <td style={{ padding: 10, maxWidth: 420 }}>{item.cleanMessage || "-"}</td>
                <td style={{ padding: 10 }}>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <button
                      type="button"
                      onClick={() => openTicket(item.ticketUuid)}
                      disabled={!item.ticketUuid}
                      style={{
                        border: 0,
                        borderRadius: 8,
                        padding: "8px 12px",
                        background: item.ticketUuid ? "#111827" : "#cbd5e1",
                        color: "#fff",
                        fontWeight: 800,
                        cursor: item.ticketUuid ? "pointer" : "not-allowed"
                      }}
                    >
                      Abrir atendimento
                    </button>

                    <button
                      type="button"
                      onClick={() => reactivateSchedule(item)}
                      style={{
                        border: 0,
                        borderRadius: 8,
                        padding: "8px 12px",
                        background: "#16a34a",
                        color: "#fff",
                        fontWeight: 800,
                        cursor: "pointer"
                      }}
                    >
                      Reativar disparo
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecoveryManualCanceledCard;
